import { createSelector } from "@reduxjs/toolkit";
import { RootState } from ".";
import {
  GOAL_A_BOX_ID,
  GOAL_BOX_IDS,
  GOAL_B_BOX_ID,
  TURN_BOX_IDS,
} from "../constants/box_id";
import { BoxId } from "../types/box_id";

export const selectHasHandByBoxId = createSelector(
  [(state: RootState) => state.handPositionBoxId, (_, boxId: number) => boxId],
  (handPositionBoxId, boxId) => {
    return handPositionBoxId === boxId;
  }
);

export const selectBoxBallCountByBoxId = createSelector(
  [(state: RootState) => state.boxBallCount, (_, boxId: number) => boxId],
  (boxBallCount, boxId) => {
    return boxBallCount[boxId];
  }
);

export const selectIsBoxDisabledByBoxId = createSelector(
  [
    (state: RootState) => state.boxBallCount,
    (state: RootState) => state.handBallCount,
    (state: RootState) => state.turn,
    (_, boxId: BoxId) => boxId,
  ],
  (boxBallCount, handBallCount, turn, boxId) => {
    if (GOAL_BOX_IDS.includes(boxId)) return true;
    if (handBallCount > 0) return true;
    if (boxBallCount[boxId] === 0) return true;
    return !TURN_BOX_IDS[turn].includes(boxId);
  }
);

export const selectIsBoxStealByBoxId = createSelector(
  [(state: RootState) => state.stealPositionBoxId, (_, boxId: BoxId) => boxId],
  (stealPositionBoxId, boxId) => {
    return stealPositionBoxId === boxId;
  }
);

export const selectIsGameFinish = createSelector(
  (state: RootState) => state.boxBallCount,
  (boxBallCount) => {
    const countA = TURN_BOX_IDS.A.reduce((prevCount, nextBoxId) => {
      return prevCount + boxBallCount[nextBoxId];
    }, 0);
    const countB = TURN_BOX_IDS.B.reduce((prevCount, nextBoxId) => {
      return prevCount + boxBallCount[nextBoxId];
    }, 0);
    return countA === 0 || countB === 0;
  }
);

export const selectGoalCoinCountA = createSelector(
  (state: RootState) => state.boxBallCount,
  (boxBallCount) => {
    return boxBallCount[GOAL_A_BOX_ID];
  }
);

export const selectGoalCoinCountB = createSelector(
  (state: RootState) => state.boxBallCount,
  (boxBallCount) => {
    return boxBallCount[GOAL_B_BOX_ID];
  }
);
